import React, { useRef, useState } from 'react';
import { View, Text, Image, TouchableOpacity } from 'react-native-web';

// Custom Component
import { Button, TextBox } from '../../components';

// Root Navigation
import * as RootNavigation from '../../navigation/RootNavigation';
import routeKeys from '../../navigation/RouteKeys';

// Configs
import GLOBAL from '../../configs/config_global';
import { sendResetPasswordEmail } from '../../modules';
import { showAlert, showAppError } from '../../utils/util_helpers';
import Feather from 'react-native-vector-icons/dist/Feather';
import { useRoute } from '@react-navigation/native';
import { setGlobalState, STATE_KEYS } from '../../configs/config_state';

export function ForgotPassword() {
    const { isAddingAccount = false } = useRoute()?.params || {};

    // region Refs
    const txtEmail = useRef(null);
    // endregion

    // region Local State
    const [email, setEmail] = useState('');
    const [isLoading, setLoading] = useState(false);
    // endregion

    // region Function - Send Forgot Password
    const goSubmitEmail = () => {
        setLoading(true);
        sendResetPasswordEmail(email)
            .then(() => {
                RootNavigation.reset(routeKeys.WELCOME);
                showAlert({ text: 'We just sent an email with instructions on how to reset your password, please check your inbox.' });
            })
            .catch((error) => {
                if (error === 'The selected email is invalid.') {
                    showAlert({ text: 'We could not find your email address in the system, make sure you spelled it correctly' });
                }
                else showAppError(error);
            })
            .finally(() => setLoading(false));
    };
    // endregion

    // region MAIN RENDER
    const logoWidth = 220;
    return(
        <View style={{ width: '100%', flex: 1, alignItems: 'center', padding: 64, backgroundColor: '#FFF' }}>
            {/* Logo */}
            <Image
                source={require('../../images/logo_vendor_landscape.png')}
                style={{ width: logoWidth, height: (34 / 156) * logoWidth, marginTop: 64 }}
            />

            {/* Main Content */}
            <View style={{ width: '50%', flex: 1, alignSelf: 'center', alignItems: 'center', paddingTop: 128 }}>
                {/* Welcome Text */}
                <Text style={{ fontSize: 40, fontWeight: '900', textAlign: 'center' }}>
                    Forgot your password?
                </Text>

                {/* Description */}
                <Text style={{ color: GLOBAL.COLOR.TEXT_GRAY, lineHeight: 28, marginVertical: 36, textAlign: 'center' }}>
                    Enter the email address associated with your account, and we will email you a link to reset your password
                </Text>

                {/* Email Input */}
                <TextBox
                    key={'txtEmail'}
                    ref={txtEmail}
                    title={'Email'}
                    placeholder={'Email'}
                    returnKeyType={'next'}
                    autoCapitalize={'none'}
                    keyboardType={'email-address'}
                    onSubmitEditing={() => goSubmitEmail()}
                    onChangeText={setEmail}
                    value={email}
                    disabled={isLoading}
                />

                {/* Submit */}
                <Button
                    style={{ marginTop: 12 }}
                    text={'Submit'}
                    locked={!email?.trim()}
                    isLoading={isLoading}
                    onPress={() => goSubmitEmail()}
                />

                {/* Back to Login */}
                <Text onPress={() => RootNavigation.goBack()} style={{ fontWeight: '500', color: GLOBAL.COLOR.BASIC.NEUTRAL_GREY, marginTop: 36 }}>
                    Back to login
                </Text>
            </View>

            {/* Back Button (for adding account) */}
            {
                isAddingAccount &&
                <TouchableOpacity
                    onPress={() => {
                        RootNavigation.goBack();
                        RootNavigation.pop();
                        setGlobalState(STATE_KEYS.ADDING_NEW_ACCOUNT, false);
                    }}
                    style={{ position: 'absolute', top: 64, left: 0, zIndex: 1000, flexDirection: 'row', alignItems: 'center', padding: 24 }}>
                    <Feather color={'red'} name={'arrow-left'} size={32} />
                    <Text style={{ color: 'red', fontSize: 18, fontWeight: 'bold', marginLeft: 16 }}>
                        Back to Switch Account
                    </Text>
                </TouchableOpacity>
            }
        </View>
    );
    // endregion
}
